module.exports = __webpack_public_path__ + "static/img/7.2dd5e29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/7.png
// module id = pljM
// module chunks = 0